import Image from 'next/image';
import { useT } from '../../../helpers/i18n';

import Consts from '../../../helpers/class/Consts';
import FooterMenu from '../menu/FooterMenu';
import PolicyNotice from '../partials/PolicyNotice';
import LoggiaSVG from '../partials/LoggiaSVG';
import LoggiaSVGNew from '../partials/LoggiaSVGNew';

export default function FooterWithoutApps ( props ) {
  const t = useT();

  return (
    <footer className={'footer bg-design-color pb-4 pt-5 xs-p-b-95 mt-auto ' + props.footerClass + " " + (props.footerPaddingClass!=null?props.footerPaddingClass:'') } style={ props.fixed ? { paddingBottom: '7.625rem' } : {}}>
      <div className="container">
        <div className={'row'}>
          <div className={'col-12 col-lg-6 justify-content-center justify-content-lg-start'}>
            <FooterMenu menu={props.menu}/>
            {
              props.registrationNumberText != null ?
                <p className="fs-11 w-100 text-left text-lg-start no-margin p-l-5" style={{ marginTop: '10px' }}>
                  {t('footer.license')}<span className="fw-bold">{props.registrationNumber}</span>
                </p>
                :''
            }
          </div>
          <div id={'w3c_div'} className={'col-12 col-lg-6 justify-content-center justify-content-lg-end text-lg-end py-3 py-lg-0'} style={{ textAlign: 'center' }}>
            <p className={'fs-11'}>{t('footer.copyright', { year: new Date().getFullYear(), title: props.title ?? '' })}</p>
            <PolicyNotice hasPrivacyPolicy={props.hasPrivacyPolicy} hasTermsAndConditions={props.hasTermsAndConditions} />
          </div>
        </div>
        {
          props.hasLoggiaBadge ?
            <div className={'row justify-content-center text-center pt-3'}>
              <a href="https://revplus.com/" target="_blank" aria-label="Powered by revplus"
                title="Powered by revplus" rel="noreferrer" className="w-auto">
                <LoggiaSVGNew footerClass={props.footerClass} />
              </a>
            </div>
            : ''
        }
      </div>
    </footer>
  )
}
